<template>
  <div class="bg-white">
    <GalleryDetails />
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import GalleryDetails from "./GalleryDetails.vue";
import Footer from "../../../Footer.vue";
import DownloadApp from "../../../home/components/DownloadApp.vue";
export default {
  components: {
    GalleryDetails,
    DownloadApp,
    Footer,
  },
};
</script>
